import {createSlice} from "@reduxjs/toolkit";
import {fetchAppbars} from "./globalComponentsThunks";

export const appbarsRepoSlice = createSlice({
    name: 'appbarsRepo',
    initialState: {
        appbarsRepo: [],
        loading: true,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAppbars.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAppbars.fulfilled, (state, action) => {
                state.loading = false;
                state.appbarsRepo = action.payload;
            })
            .addCase(fetchAppbars.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export default appbarsRepoSlice.reducer;